export default __webpack_public_path__ + "static/media/animal-37.601a5569.svg";